export default "__VITE_PUBLIC_ASSET__d04edec0__"